.biel-button-content {
  cursor: pointer;
  max-width: fit-content;
  z-index: var(--biel-button-z-index);
}

.biel-button-content--light{
  align-items: center;
  background-color: var(--biel-button-light-bg-color);
  border-radius: var(--biel-button-border-radius);
  box-shadow: var(--biel-button-box-shadow);
  box-sizing: border-box;
  color: var(--biel-button-light-text-color);
  display: flex;
  font-family: var(--biel-font-family);
  font-size: var(--biel-button-text-font-size);
  font-weight: var(--biel-button-text-font-weight);
  padding: 8px 15px;
}

.biel-button-content--light:hover{
  background-color: var(--biel-button-light-bg-color-hover);
}

.biel-button-content--dark{
  align-items: center;
  background-color: var(--biel-button-dark-bg-color);
  border-radius: var(--biel-button-border-radius);
  box-shadow: var(--biel-button-box-shadow);
  box-sizing: border-box;
  color: var(--biel-button-dark-text-color);
  display: flex;
  font-family: var(--biel-font-family);
  font-weight: var(--biel-button-text-font-weight);
  font-size: var(--biel-button-text-font-size);
  padding: var(--biel-button-padding);
}

.biel-button-content--dark:hover{
  background-color: var(--biel-button-dark-bg-color-hover);
}

.biel-button-content--bottom-right{
  bottom: var(--biel-button-position-bottom);
  position: fixed;
  right: var(--biel-button-position-right);
}

.biel-button-content--bottom-left{
  bottom: var(--biel-button-position-bottom);
  position: fixed;
  left: var(--biel-button-position-left);
}

.biel-button-content--center-right{
  position: fixed;
  transform: rotate(-90deg) translateY(-50%);
  top: 50%;
}

.biel-button-content--center-left{
  position: fixed;
  transform: rotate(90deg) translateY(100%);
  top: 50%;
}

.biel-button-content--center-right.biel-button-content--dark,
.biel-button-content--center-right.biel-button-content--light,
.biel-button-content--center-left.biel-button-content--dark,
.biel-button-content--center-left.biel-button-content--light {
  border-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.biel-button-content--custom {
  position: fixed;
  top: var(--biel-button-position-top);
  bottom: var(--biel-button-position-bottom);
  right: var(--biel-button-position-right);
  left: var(--biel-button-position-left);
}

.biel-button-content-icon {
  height: var(--biel-button-icon-size);
  margin-right: 5px;
  width: var(--biel-button-icon-size);
}

.biel-button-content--center-right .biel-button-content-icon {
  rotate: 90deg;
}

.biel-button-content--center-left .biel-button-content-icon {
  rotate: -90deg;
}